import React, { useState, useEffect } from 'react';
import styles from '../static/styles/Leaderboard.module.css';
import { fetchLeaderboard } from '../api/leaderboard';
import crownIcon from '../static/img/Leaderboard/iconCrown.svg';
import positionBgIcon from '../static/img/Leaderboard/iconPositionBg.svg';
import defaultAvatar from '../static/img/Sidebar/Avatar.png';
import backArrowIcon from '../static/img/backSquircle.svg';
import positionHolderBG from '../static/img/Leaderboard/leaderboardPodiumBG.svg';

const trimText = (text, maxLength = 9) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '..';
  }
  return text;
};

const Leaderboard = () => {
    const [leaderboardData, setLeaderboardData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedPlayer, setExpandedPlayer] = useState(null);

    useEffect(() => {
        document.title = "Leaderboard | Ufone ESG"
        const loadLeaderboard = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await fetchLeaderboard();
                setLeaderboardData(data);
            } catch (err) {
                setError(err.message || 'Failed to load leaderboard');
            } finally {
                setLoading(false);
            }
        };
        loadLeaderboard();
    }, []);

    const getTopThreePlayers = () => {
        return leaderboardData.slice(0, 3);
    };

    const getRemainingPlayers = () => {
        return leaderboardData.slice(3);
    };

    const handlePlayerClick = (playerName) => {
        if (expandedPlayer === playerName) {
            setExpandedPlayer(null);
        } else {
            setExpandedPlayer(playerName);
        }
    };

    if (loading) return <div className={styles.loading}>Loading...</div>;
    if (error) return <div className={styles.error}>Error: {error}</div>;

    const topThree = getTopThreePlayers();
    const remainingPlayers = getRemainingPlayers();

    return (
        <div className={styles.container}>
            {/* <div className={styles.backButton}>
                <img src={backArrowIcon} alt="Back" />
            </div> */}
            <h1 className={styles.title}>Leaderboard</h1>

            {/* Top 3 Players */}
            <div className={styles.topThreeContainer}>
                {topThree.map((player, index) => {
                    const position = index + 1;
                    const isFirst = position === 1;
                    const isSecond = position === 2;
                    const isThird = position === 3;
                    
                    const orderClass = isFirst ? styles.first : isSecond ? styles.second : styles.third;
                    
                    return (
                        <div 
                            key={player.name}
                            className={`${styles.topPlayerCard} ${orderClass}`}
                        >
                            <div className={styles.playerAvatar}>
                                {isFirst && (
                                    <img src={crownIcon} alt="Crown" className={styles.crownIcon} />
                                )}
                                <img 
                                    src={player.profileImage || defaultAvatar} 
                                    alt={player.name} 
                                    className={styles.avatarImage}
                                    onError={e => { e.target.onerror = null; e.target.src = defaultAvatar; }}
                                />
                            </div>
                            <div className={styles.playerPosition}>
                                <img src={positionBgIcon} alt="" className={styles.positionBg} />
                                <span>{position}</span>
                            </div>
                            <div className={styles.playerContent}>
                                <div className={styles.playerName}>{trimText(player.name)}</div>
                                <div className={styles.playerScore}>{player.score}</div>
                                <div className={styles.playerUsername}>@{trimText(player.username || player.name.toLowerCase().replace(/\s+/g, ''))}</div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={styles.playersList}>
                {remainingPlayers.map((player, index) => (
                    <div key={player.name} className={styles.playerListItem}>
                        <div 
                            className={`${styles.playerRow} ${expandedPlayer === player.name ? styles.expanded : ''}`}
                            onClick={() => handlePlayerClick(player.name)}
                        >
                            <div className={styles.expandIcon}>
                                {expandedPlayer === player.name ? '▼' : '▲'}
                            </div>
                            <div className={styles.position}>{index + 4}</div>
                            <img 
                                src={player.profileImage || defaultAvatar} 
                                alt={player.name} 
                                className={styles.listAvatar}
                                onError={e => { e.target.onerror = null; e.target.src = defaultAvatar; }}
                            />
                            <div className={styles.listPlayerName}>{trimText(player.name)}</div>
                            <div className={styles.listPlayerScore}>{player.score} credits</div>
                            
                        </div>
                        
                        {expandedPlayer === player.name && (
                            <div className={styles.expandedDetails}>
                                <div className={styles.detailItem}>
                                    <span>Credits</span>
                                    <span>{player.score}</span>
                                </div>
                                <div className={styles.detailItem}>
                                    <span>Tournaments Played</span>
                                    <span>{player.total_tournaments}</span>
                                </div>
                                <div className={styles.detailItem}>
                                    <span>Price Redeemed</span>
                                    <span>{player.redeemed_items}</span>
                                </div>
                                <div className={styles.detailItem}>
                                    <span>Completed Challenges</span>
                                    <span>{player.total_challenges}</span>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Leaderboard;